import { render, staticRenderFns } from "./userOverOrder.vue?vue&type=template&id=ef480d78&scoped=true&"
import script from "./userOverOrder.vue?vue&type=script&lang=js&"
export * from "./userOverOrder.vue?vue&type=script&lang=js&"
import style0 from "./userOverOrder.vue?vue&type=style&index=0&id=ef480d78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef480d78",
  null
  
)

export default component.exports